import './Overlay-32ffdedc.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl","overlay-appear":"prc-Overlay-overlay-appear-DGY3B"};

export { classes as default };
